Turbo.StreamActions.user_created = function () {
  const activity = {
    userID: this.getAttribute("user_id"),
    membershipID: this.getAttribute("membership_id"),
    ptpSource: this.getAttribute("ptp_source"),
  }
  posthog.identify(activity.userID, {
    email: null,
    membership_id: activity.membershipID,
  })
  Activity.track_subscription(activity.ptpSource)
}

Turbo.StreamActions.init_header_dropdowns = function () {
  // Initilise user dropdown after signing in
  initDropdowns($(".header .dropdown-container"))
}
